import { Dispatch, SetStateAction } from 'react';
import {
  ToolsRoles,
  isAbleToSeeUIElement,
} from '../../../utils/roles/client-roles';

import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

interface GroupReportsMenuProps {
  anchorEl: null | HTMLElement;
  open: boolean;
  handleClose: () => void;
  setOpenReportsDialog: (open: boolean) => void;
  setSelectedReport: Dispatch<
    SetStateAction<{
      displayName: string;
      reportType: string;
      role: string;
    } | null>
  >;
  toolsRoles: string[];
}

const reports = [
  {
    displayName: 'Group',
    reportType: 'groupReport',
    role: ToolsRoles.RunGroupExport.value,
  },
  {
    displayName: 'Group Member Count',
    reportType: 'groupMemberCountReport',
    role: ToolsRoles.RunGroupMemberCountReport.value,
  },
  {
    displayName: 'Group Membership',
    reportType: 'groupMembershipReport',
    role: ToolsRoles.RunGroupMembership.value,
  },
];

export default function GroupReportsMenu({
  anchorEl,
  open,
  handleClose,
  setOpenReportsDialog,
  setSelectedReport,
  toolsRoles,
}: GroupReportsMenuProps) {
  return (
    <Menu
      id="reports-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      MenuListProps={{
        'aria-labelledby': 'user-reports',
      }}
    >
      {reports.map((report) => (
        <MenuItem
          key={report.displayName}
          onClick={(e) => {
            e.stopPropagation();
            setSelectedReport(report);
            setOpenReportsDialog(true);
            handleClose();
          }}
          disabled={!isAbleToSeeUIElement(toolsRoles, report.role)}
        >
          {report.displayName}
        </MenuItem>
      ))}
    </Menu>
  );
}
